var React = require('react');

function CloseTiny (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.85.404l.708.707L5.668 5l3.89 3.89-.707.706-3.89-3.89-3.888 3.89-.708-.707L4.255 5 .364 1.112l.708-.707L4.96 4.293 8.85.403z","fill":"#484848","fillRule":"evenodd"}));
}

CloseTiny.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10"};

module.exports = CloseTiny;

CloseTiny.default = CloseTiny;
